import { Fuzzy } from '@utils/fuse-search'
import { Action, ActionType, FieldOption, State } from './types'

function fuzzySearch(collection: FieldOption[], term: string): FieldOption[] {
  const fuzzy = new Fuzzy(collection, { keys: ['name'] }, 0.3)
  const results = fuzzy.search(term)

  return results
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.clearSearch: {
      const { searchTerm } = action.payload

      return {
        ...state,
        searchTerm,
      }
    }

    case ActionType.resetToInitialState: {
      const { selected } = action.payload

      return {
        ...state,
        selected,
      }
    }

    case ActionType.setSearchResults: {
      const { searchTerm } = action.payload
      const { options } = state

      const results = fuzzySearch(options, searchTerm)

      return {
        ...state,
        searchResults: results,
        searchTerm,
      }
    }

    case ActionType.setSelected: {
      const { fieldId } = action.payload
      const { selected } = state

      if (selected.some(selectedField => selectedField.concatenation_field_id === fieldId)) {
        return {
          ...state,
          selected: selected.filter(
            selectedField => selectedField.concatenation_field_id !== fieldId,
          ),
        }
      }

      const field = state.options.find(field => field.id === fieldId)
      if (!field) return state

      const governanceField = {
        field_id: field.id,
        concatenation_list_id: null,
        concatenation_list_column_id: null,
        concatenation_field_id: field.id,
        concatenation_field_name: field.name,
        precedence: selected.length,
      }

      return {
        ...state,
        selected: [...selected, governanceField],
      }
    }
  }
}
